<script setup>
import './styles/App.css'
import ActionButton from '#elements/ActionButton.vue'
import getCurrentLanguage from '#helpers/getCurrentLanguage.js'
import setI18nLanguage from '#helpers/i18n/setI18nLanguage.js'
import { showModal } from '#helpers/modals.js'
import { usePreferencesStore } from '#stores/usePreferencesStore.js'
import { useHead } from '@unhead/vue'
import { useStorage } from '@vueuse/core'
import { container as WidgetContainerModal } from 'jenesius-vue-modal'
import { computed, defineAsyncComponent, inject, onMounted, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

const DebuggerTool = defineAsyncComponent(() => import('#src/components/Debug/DebuggerTool.vue'))
const LayoutAuth = defineAsyncComponent(() => import('#src/components/Layouts/LayoutAuth.vue'))
const LayoutNone = defineAsyncComponent(() => import('#src/components/Layouts/LayoutNone.vue'))
const LayoutNormal = defineAsyncComponent(() => import('#src/components/Layouts/LayoutNormal.vue'))

const debuggerVisible = useStorage('debugger-visible', false)
const i18n = useI18n()
const matomo = inject('matomo')
const route = useRoute()
// necessary to pick up the theme everywhere
const _preferences = usePreferencesStore()

// const date = new Date()
useHead({
	// bodyAttrs: {
	// 	style: date.getUTCMonth() === 1 && date.getDate() === 5 ? 'font-family: "Comic Sans MS", fantasy, sans-serif;' : '',
	// },
	title: 'Home',
	titleTemplate: '%s %separator %module %separator %siteName',
	templateParams: { module: null, siteName: import.meta.env.VITE_APP_NAME },
})

const layout = ref(route?.meta?.layout ?? 'normal')
const layouts = { auth: LayoutAuth, none: LayoutNone, normal: LayoutNormal }

const layoutComponent = computed(() => {
	return layouts[layout.value]
})

// Don't watch route since it doesn't support comparing old vs new values
watch(
	() => route.fullPath,
	() => {
		layout.value = route?.meta?.layout ?? 'normal'
		matomo.push(['setCustomDimension', 1, window.innerWidth])
		matomo.push(['setCustomDimension', 2, window.innerHeight])
	},
	{ immediate: true },
)

watch(i18n.locale, language => {
	i18n.locale.value = language
	localStorage.language = language
	document.querySelector('html').setAttribute('lang', language)
})

watch(debuggerVisible, newValue => {
	if (newValue === true) {
		openDebugger()
	}
})

function openDebugger() {
	showModal(DebuggerTool)
}

onMounted(() => {
	const language = getCurrentLanguage()
	setI18nLanguage(language)

	document.addEventListener('keydown', event => {
		const isInputElement =
			document.activeElement.tagName === 'INPUT' ||
			document.activeElement.tagName === 'TEXTAREA' ||
			document.activeElement.isContentEditable

		const isShortcutPressed =
			event.ctrlKey && event.altKey && event.shiftKey && event.keyCode === 67 // 'c'

		if (isShortcutPressed && !isInputElement) {
			event.preventDefault()
			debuggerVisible.value = true
		}
	})
})
</script>

<template>
	<div id="app">
		<component :is="layoutComponent" :key="layoutComponent">
			<router-view />
		</component>

		<ActionButton
			v-if="debuggerVisible"
			icon="Bug"
			class="DebugButton"
			accesskey="d"
			context="secondary"
			@click="openDebugger"
		>
			Debug
		</ActionButton>
		<widget-container-modal />
	</div>
</template>
